export enum ENoNc {
  NO,
  NC
}
